import React from 'react';
import PropTypes from 'prop-types';

const ArrowLeft = (props) => {
  return (
    <svg width={56} height={56} viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g transform="translate(-410 -1244)">
        <use xlinkHref="#arrowleft-path0_fill" transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 445.63 1277.38)" fill={props.fillColor} />
      </g>
      <defs>
        <path id="arrowleft-path0_fill" fillRule="evenodd" d="M 11.0317 6.54785L 8.19159 9.38806L 9.68793 10.8844L 15.13 5.44214L 14.3409 4.65308L 13.6337 3.9458L 9.68793 0L 8.19159 1.49634L 11.127 4.43176L 0 4.43176L 0 6.54785L 11.0317 6.54785Z" />
      </defs>
    </svg>
  );
}
ArrowLeft.propTypes = {
  fillColor: PropTypes.string,
}

export default ArrowLeft;